import React, { useEffect } from "react";
import "animate.css"; // Certifique-se de instalar a biblioteca animate.css
import { useInView } from "react-intersection-observer"; // Biblioteca para detectar visibilidade
import defensiva1 from "../img/defensiva1.png";
import MenuLeft from "./MenuLeft";


const InvestigacaoDefensivaComp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Função para aplicar animação quando o elemento estiver visível
  const AnimatedElement = ({ children, animationClass }) => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
    return (
      <div
        ref={ref}
        className={`animate__animated ${inView ? animationClass : "animate__fadeOut"}`}
      >
        {children}
      </div>
    );
  };

  return (
    <>
      <div id="merox-blog-area" className="merox-blog-area mt-100 mb-100">
        <div className="container">
          <div className="row">
            <div id="menu-left" className="col-xl-4 col-lg-4">
              <MenuLeft />
            </div>
            <div className="col-xl-8 col-lg-8 pr-30">
              <div className="merox-blog-details-wraper">
                <div className="blog-details-content">
                  <div className="mb-4">
                    <AnimatedElement animationClass="animate__fadeIn">
                      <img
                        src={defensiva1}
                        alt="img"
                        className="w-100"
                      />
                    </AnimatedElement>
                  </div>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <h4 style={{ color: "#9B0008" }}>
                      Base Legal da Investigação Defensiva
                    </h4>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <p>
                      A investigação defensiva é reconhecida como instrumento
                      legítimo da ampla defesa e do contraditório, conforme a
                      Resolução nº 181/2017 do CNMP e o Provimento nº 188/2018
                      da OAB, que regulamentam a atuação investigativa da
                      advocacia. Além disso, nossa prática encontra respaldo na
                      Lei nº 13.432/2017, que disciplina a atividade de
                      investigação particular no Brasil.
                    </p>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <h4 style={{ color: "#9B0008" }}>Âmbitos de Atuação</h4>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <p>
                      Embora seja frequentemente associada ao direito penal, a
                      investigação defensiva não se limita a casos criminais. Ela
                      pode ser aplicada em processos cíveis, trabalhistas,
                      familiares, empresariais e administrativos, sempre que a
                      defesa necessitar de elementos probatórios para sustentar
                      seus argumentos. Dessa forma, amplia-se a sua relevância
                      prática, tornando-a uma ferramenta indispensável em
                      diferentes ramos do direito.
                    </p>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <h4 style={{ color: "#9B0008" }}>
                      Compromisso Ético e Técnico
                    </h4>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <p>
                      Todas as atividades são conduzidas com rigor técnico, sigilo
                      e respeito à legalidade, garantindo que os relatórios e
                      levantamentos possam ser utilizados como elementos de prova
                      ou indícios lícitos dentro de processos judiciais ou
                      administrativos. O objetivo é fornecer à advocacia um
                      material robusto, confiável e capaz de fortalecer a
                      estratégia de defesa.
                    </p>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <h4 style={{ color: "#9B0008" }}>
                      Diferencial para a Defesa
                    </h4>
                  </AnimatedElement>

                  <AnimatedElement animationClass="animate__fadeInUp">
                    <p>
                      A união da investigação particular com a investigação
                      defensiva representa um diferencial estratégico: amplia o
                      acesso a informações, fortalece a produção de provas e
                      permite que o advogado construa uma defesa mais completa e
                      bem fundamentada, independentemente da área jurídica em que
                      o caso esteja inserido.
                    </p>
                  </AnimatedElement>
                </div>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvestigacaoDefensivaComp;
